<script lang="ts">
  import JsonNode from "./JsonNode.svelte";

  interface Props {
    data: string;
    defaultOpen?: boolean;
  }

  const { data, defaultOpen = true }: Props = $props();

  const { parsed, failed } = $derived.by(() => {
    try {
      return { parsed: JSON.parse(data), failed: false };
    } catch {
      return { parsed: null, failed: true };
    }
  });
</script>

{#if failed}
  <span class="font-mono text-xs whitespace-pre-wrap text-mono-800">{data}</span>
{:else}
  {#key data}
    <JsonNode data={parsed} {defaultOpen} />
  {/key}
{/if}
